/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect }from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { useTranslation } from "react-i18next";
import { Tabs } from "antd";
import 'antd/dist/antd.min.css';

import { isEmpty, getTime } from 'script/common';
import * as types from 'reducer/actionTypes';

const Monitoring = () => {
	const {t} = useTranslation();
	const dispatch = useDispatch();
	const { tabs } = useSelector((state) => state.monitoring);

	useEffect(() => {
		// 컴포넌트가 마운트될 때 startRealtimeData 액션을 디스패치하여 사가 실행 시작
		dispatch({type: types.FETCH_REALTIME_MONITORING_DATA_REQUEST})
	
		// 컴포넌트 언마운트 시에 stopRealtimeData 액션을 디스패치하여 사가 실행 중지
		return () => {
			dispatch({type: types.FETCH_REALTIME_MONITORING_DATA_REQUEST_STOP})
		};
	  }, [dispatch]);
	  
	  const getChartData = (data, service) => {
		let newData = [];
		if (!isEmpty(data)) {
			data.map((d) => {
				let time = getTime(new Date(d?.healthCheckTime))
				let status = (d?.[service]?.result) ? 0 : -1
				newData.push({"x": time, "y": status})
			})
			newData = Array.from(newData).reverse()
		}
		
		return newData
	}
	  
	  return (
		<>
			<h2>{t('monitoring.main.title')}</h2>
			<div className="content_box">
				{tabs.size < 1 ? null : 
					<Tabs
						defaultActiveKey='1'
						type='card'
						size={tabs.size}
						items={tabs.map((data,i) => {
							const id = String(i+1);
							return {
								key : id,
								label : data.label,
								children : <data.component getChartData={getChartData}/>
							}
						})}
					/>
				}
			</div>
		</>
	)
}

export default Monitoring;